import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  FaPalette,
  FaBoxOpen,
  FaEnvelope,
  FaUser,
  FaSignOutAlt,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import wedifyLogo from "../../assets/logo/wedify-logo-white.png";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Handle scroll event
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const dashboardMenuItems = [
    {
      name: "Atur Tema",
      path: "set-theme",
      icon: <FaPalette />
    },
    {
      name: "Paket",
      path: "packet",
      icon: <FaBoxOpen />
    },
    {
      name: "Kontak Kami",
      path: "contact-us",
      icon: <FaEnvelope />
    }
  ];

  const accountMenuItems = [
    {
      name: "Profil",
      path: "profile",
      icon: <FaUser />
    },
    {
      name: "Keluar",
      path: "logout",
      icon: <FaSignOutAlt />
    }
  ];

  return (
    <>
      {/* FAB for mobile */}
      {!isOpen && (
        <button
          className={`lg:hidden fixed top-5 left-3 z-50 text-black transition-opacity duration-300 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-0"
          }`}
          onClick={() => setIsOpen(true)}
        >
          <FaBars size={24} />
        </button>
      )}

      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-40 w-64 bg-[#962A61] text-[#FAFAFA] font-montserrat p-5 transform transition-transform duration-300 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 lg:relative lg:flex`}
      >
        {/* Mobile close button */}
        <button
          className="lg:hidden absolute top-5 right-5 text-white"
          onClick={() => setIsOpen(false)}
        >
          <FaTimes size={24} />
        </button>

        <div className="w-full">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img src={wedifyLogo} alt="Wedify Logo" className="w-32" />
          </div>

          <hr className="border-[#E4E4E7] mb-4" />

          {/* Dashboard Menu */}
          <div className="space-y-2">
            <p className="text-sm font-semibold">DASHBOARD SAYA</p>
            {dashboardMenuItems.map((item, index) => (
              <NavLink
                key={index}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center space-x-3 p-2 rounded-lg cursor-pointer transition-all duration-200 ${
                    isActive
                      ? "bg-white bg-opacity-30"
                      : "hover:bg-white hover:bg-opacity-30"
                  }`
                }
                onClick={() => setIsOpen(false)}
              >
                {item.icon}
                <span>{item.name}</span>
              </NavLink>
            ))}
          </div>

          <hr className="border-[#E4E4E7] my-4" />

          {/* Account Menu */}
          <div className="space-y-2">
            <p className="text-sm font-semibold">AKUN</p>
            {accountMenuItems.map((item, index) => (
              <NavLink
                key={index}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center space-x-3 p-2 rounded-lg cursor-pointer transition-all duration-200 ${
                    isActive
                      ? "bg-white bg-opacity-30"
                      : "hover:bg-white hover:bg-opacity-30"
                  }`
                }
                onClick={() => setIsOpen(false)}
              >
                {item.icon}
                <span>{item.name}</span>
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </>
  );
};

export default Sidebar;